import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "mr-6 pt-3"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-grow" }
const _hoisted_5 = {
  key: 1,
  class: "italic"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 3,
  class: "italic"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "opacity-80" }
const _hoisted_15 = { class: "opacity-80" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import { ContactRole, ProductTechnology, Technology, TechnologyType } from "@/model";
import { useRoute } from "vue-router";
import Heading from "@/components/Heading.vue";
import { computed, Ref } from "vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";

type Contact = {
  name: string
  email: string
  productRoles: {
    product: string
    roles: ContactRole[]
  }[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TechnologyView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const technology: Technology = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('technologies').getOne<Technology>(route.params.id))),
  __temp = await __temp,
  __restore(),
  __temp
);
const productTechnologies: ProductTechnology[] = (
  ([__temp,__restore] = _withAsyncContext(() => pb.collection('product_technologies').getFullList<ProductTechnology>(null, {
  expand: 'product,technology,product.businessUnit,product.contacts',
  sort: 'product.name',
  filter: `technology = '${technology.id}'`,
}))),
  __temp = await __temp,
  __restore(),
  __temp
);

const contacts = computed(() => {
  const map = new Map<string, Contact>()
  for (const productTechnology of productTechnologies) {
    for (const contact of productTechnology.expand?.product?.expand?.contacts || []) {
      if (!map.has(contact.email)) {
        map.set(contact.email, {
          name: contact.name,
          email: contact.email,
          productRoles: [],
        });
      }
      map.get(contact.email)!.productRoles.push({
        product: productTechnology.expand!.product!.name,
        roles: contact.roles,
      });
    }
  }

  return [...map.values()].sort((a, b) => a.name.localeCompare(b.name));
});

const imageUrl: Ref<string | null> = computed(() => {
  if (technology.simpleicon) {
    return `https://cdn.simpleicons.org/${technology.simpleicon}`;
  }

  return technology.logo.length > 0 ? pb.files.getUrl(technology, technology.logo) : null
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, {
      subtitle: `Technologies > ${_unref(TechnologyType)[_unref(technology).type]}`
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(technology).name), 1)
      ]),
      _: 1
    }, 8, ["subtitle"]),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (imageUrl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: imageUrl.value,
                  alt: `Logo of ${_unref(technology).name}`,
                  class: "w-24 h-24 object-contain"
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Heading, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Description")
              ])),
              _: 1,
              __: [0]
            }),
            (_unref(technology).description.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(technology).description), 1)
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "No description available")),
            _createVNode(Heading, null, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Website")
              ])),
              _: 1,
              __: [1]
            }),
            (_unref(technology).website.length > 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: _unref(technology).website,
                  class: "default-anchor",
                  target: "_blank"
                }, _toDisplayString(_unref(technology).website), 9, _hoisted_6))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, "No website available"))
          ])
        ]),
        _createVNode(Heading, null, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Products that use this technology")
          ])),
          _: 1,
          __: [2]
        }),
        (_unref(productTechnologies).length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " No products seem to be using this technology. You're on your own, sorry buddy. "))
          : _createCommentVNode("", true),
        (_unref(productTechnologies).length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Business Unit"),
                  _createElementVNode("th", null, "Product"),
                  _createElementVNode("th", { class: "text-right" }, "Version"),
                  _createElementVNode("th", null, "Comment")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productTechnologies), (productTechnology) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(productTechnology.expand!.product!.expand!.businessUnit!.name), 1),
                    _createElementVNode("td", null, _toDisplayString(productTechnology.expand!.product!.name), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(productTechnology.version || 'n/a'), 1),
                    _createElementVNode("td", null, _toDisplayString(productTechnology.comment || 'n/a'), 1)
                  ]))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(productTechnologies).length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(Heading, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("People who can help you")
                ])),
                _: 1,
                __: [4]
              }),
              (contacts.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, " None of the products have any contacts defined. Maybe try reaching out in a group chat? "))
                : _createCommentVNode("", true),
              (contacts.value.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Name"),
                        _createElementVNode("th", null, "Email"),
                        _createElementVNode("th", null, "Role")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(contact.name), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              class: "default-anchor",
                              href: `mailto:${contact.email}?subject=${encodeURIComponent('Question about ' + _unref(technology).name)}`
                            }, _toDisplayString(contact.email), 9, _hoisted_13)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contact.productRoles, (productRole) => {
                              return (_openBlock(), _createElementBlock("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productRole.roles, (role, idx) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (idx > 0)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" and ")
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(ContactRole)[role]), 1)
                                  ], 64))
                                }), 256)),
                                _cache[5] || (_cache[5] = _createTextVNode(" for ")),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(productRole.product), 1)
                              ]))
                            }), 256))
                          ])
                        ]))
                      }), 256))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})